import { t } from '@lingui/core/macro';
import { DinteroErrorTypes } from '../types/dinteroPayment';

export function getErrorTextBasedOnErrorType(error: DinteroErrorTypes | string | null) {
  switch (error) {
    case 'cancelled':
      return t`Payment cancelled`;
    case 'authorization':
    case 'failed':
    case 'capture':
      return t`Payment failed`;
    default:
      return t`Payment failed`;
  }
}
